import script from "./MobileMatchMajor.vue?vue&type=script&lang=ts&setup=true"
export * from "./MobileMatchMajor.vue?vue&type=script&lang=ts&setup=true"

import "./MobileMatchMajor.vue?vue&type=style&index=0&id=6b4c236a&scoped=true&lang=css"

import exportComponent from "D:\\code\\frontEndCode\\collegeSubjectPage\\page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b4c236a"]])

export default __exports__